/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('CancellationPolicyTooltip', {
  Link: 'Cancellation Policy',
  Tooltip: 'Account owners may cancel a Viewpost subscription at any time in their Company Settings. Accounts remain active until the end of their current billing period, after which time account functionality is limited and scheduled invoices and payments are cancelled. Accounts remain active to provide secure access to historical data. No refunds or credits are given for partial-month membership periods.'
});
